import { render, staticRenderFns } from "./DsfPptSetting.vue?vue&type=template&id=66ad761a&"
import script from "./DsfPptSetting.vue?vue&type=script&lang=js&"
export * from "./DsfPptSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "pc/control/DsfPptSetting.vue"
export default component.exports